import request from '@/api/http'
const learnCenter = {
    getConfig(params, callback) {
        return request.get(`https://publicapp.oss-cn-hangzhou.aliyuncs.com/learnCenter/config.json`, params, callback)
    },
    insert(params,callback){
        return request.post(process.env.BASE_URL+`/lvJingAPI/buriedPointInsert`, params,callback)
    },
    queryTimes(params,callback){
        return request.post(process.env.BASE_URL+`/lvJingAPI/buriedPoint`, params,callback)
    }
}


export default learnCenter